import React from 'react';
import styled from 'styled-components';
import Spinner from './spinner';
import FullViewportHeight from '../common/full_viewport_height';

const FullPageSpinner = (props) => (
  <FullPageSpinnerContainer>
    <Spinner big />
  </FullPageSpinnerContainer>);

const FullPageSpinnerContainer = styled(FullViewportHeight)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  font-weight: 700;
  font-size: 1.4em;
`;

export default FullPageSpinner;
